/**
 * http请求
 */
import axios from 'axios'
import qs from 'qs'
import { baseURL } from './config.js'
import { Message } from 'element-ui'
import { REQUEST_CODE } from './code.js'
import store from '@/store'
import router from '@/router'

// 创建http对象
const http = axios.create({
  baseURL: baseURL,
  // withCredentials: true,
  timeout: 60000,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
  }
})

// 设置http拦截器
http.interceptors.request.use(config => {
  // 请求头带入令牌
  // console.log('store.state', JSON.stringify(store.state))
  config.headers.Authorization = store.state.token
  return config
}, error => {
  Message.error('请求超时!')
  return Promise.resolve(error)
})
http.interceptors.response.use(res => {
  return res
}, error => {
  Message.error('服务器繁忙，请稍后重试')
  return Promise.reject(error)
})

export default {
  // 请求函数
  request (object) {
    const method = object.method.toUpperCase()
    let params = object.params
    if (method === 'POST') {
      if (!object.headers || (!object.headers['Content-Type'].startsWith('application/json') && !object.headers['Content-Type'].startsWith('multipart/form-data'))) {
        params = qs.stringify(params)
      }
    }
    // 设置请求参数
    object.data = method === 'POST' || method === 'PUT' ? params : null
    object.params = method === 'GET' || method === 'DELETE' ? params : null
    // 发送请求，并返回请求对象
    return new Promise((resolve, reject) => {
      http(object).then(res => {
        resolve(res.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 回调函数
  callback (res, trueCallback) {
    const code = res.code
    const codeStr = String(code)
    // 如果请求成功
    if (code === REQUEST_CODE.SUCCESS) {
      trueCallback()
    } else if (code === REQUEST_CODE.NO_LOGIN) {
      store.commit('setUser', '')
      if (router.currentRoute.meta.requireAuth) {
        router.push({
          path: '/login'
        })
      }
    } else if (codeStr.startsWith('4') || codeStr.startsWith('5')) {
      Message.error(res.msg)
    } else if (codeStr.startsWith('6')) {
      Message.warning(res.msg)
    }
  }
}
